import React, { useState } from "react";
import { Form } from "@/components/ui/form";
import { LoadingSubmitButton } from "../form_fields/LoadingSubmitButton";
import { Input } from "../ui/input";
import { t } from "i18next";
import { iCollection, patchCollection } from "@/services/collection";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";

type Props = {
  collection: iCollection;
  refresh: () => void;
  isSuperAdmin: boolean;
};

const CreditsModal = (props: Props) => {
  const { collection, isSuperAdmin, refresh } = props;

  const [credits, setCredits] = useState(collection.takoinCredits || 0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formSchema = z.object({
    credits: z.number(),
  });

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      credits: collection.takoinCredits || 0,
    },
  });

  const onSubmit = async () => {
    setIsSubmitting(true);

    try {
      await patchCollection({
        collectionId: collection._id,
        takoinCredits: credits,
      });

      console.log("ciao");

      refresh();
    } catch (error) {
      console.error(error);
    }

    setIsSubmitting(false);
  };

  if (isSuperAdmin) {
    return (
      <Form {...form}>
        <form
          className="flex flex-col gap-4"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <p>Manage credits</p>
          <Input
            value={credits}
            type="number"
            onChange={(e) => setCredits(parseInt(e.target.value))}
          />
          <div className="flex flex-row gap-4">
            <LoadingSubmitButton
              className="ml-auto"
              variant="takyon"
              type="submit"
              isLoading={isSubmitting}
              disabled={isSubmitting || collection.takoinCredits === credits}
            >
              {t("buttons.save")}
            </LoadingSubmitButton>
          </div>
        </form>
      </Form>
    );
  }

  return (
    <div className="flex flex-col gap-4 max-w-[500px]">
      <p>{t("collection.service.credits_account.subTitle")}</p>
      <p>{t("collection.service.credits_account.description")}</p>
      <div>
        <Button
          variant={"takyon"}
          onClick={() => {
            window.open(
              // "https://meetings-eu1.hubspot.com/marco-amodio",
              // `https://meetings-eu1.hubspot.com/marco-amodio?uuid=ad7ddb3e-4b41-415e-ab87-e7697321868e`,
              "https://meetings-eu1.hubspot.com/simona-graziani?uuid=450ae869-e0ec-4daa-831c-a836e49a76b9",
              "_blank"
            );
          }}
        >
          {t("collection.service.marketing.buttonText")}
        </Button>
      </div>
    </div>
  );
};

export default CreditsModal;
